import "bootstrap/dist/css/bootstrap.min.css";
import "../css/designer.css";
import { bootDesigner } from "./designer";

bootDesigner();
